export const NozzlesTypes = {
  IGetNozzlesService: Symbol("IGetNozzlesService"),
};
